import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

export const WEB_BASE_URL = 'https://www.getrevyo.com';

export function urlToWeb(path = '/') {
  if (!path) return WEB_BASE_URL;
  return path.startsWith('http') ? path : `${WEB_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
}

export function urlToFunnel(slug) {
  if (!slug) return WEB_BASE_URL;
  return `${WEB_BASE_URL}/r/${slug}`;
}

/**
 * Ouvre une URL externe.
 * - Web : nouvel onglet via window.open.
 * - Native (Capacitor) : Safari View Controller in-app via @capacitor/browser,
 *   ce qui préserve l'état de l'app (pas de window.location.href qui détruit le bundle React).
 */
export function openExternalUrl(url) {
  if (!url) return null;
  if (Capacitor.isNativePlatform()) {
    Browser.open({ url, presentationStyle: 'popover' }).catch((e) =>
      console.warn('[external] Browser.open failed:', e?.message || e)
    );
    return null;
  }
  const win = window.open(url, '_blank', 'noopener,noreferrer');
  if (!win) console.warn('[external] open blocked', url);
  return win;
}

/**
 * Ouvre un flux d'authentification externe (OAuth Google, Stripe Checkout, etc.).
 * - Native : Safari View Controller via @capacitor/browser. Préserve l'état de l'app
 *   (le JS React continue de tourner pendant l'auth, le user revient via deep link
 *   ou en fermant la sheet).
 * - Web : redirection top-level via window.location.href (Google bloque les WebView
 *   in-app et les iframes pour OAuth).
 *
 * Fallback web si Browser.open jette en native (rare, mais on ne veut pas bloquer
 * le flux paiement / OAuth).
 */
export async function openExternalAuthFlow(url) {
  if (!url) {
    console.warn('[external] openExternalAuthFlow appelé sans URL');
    return;
  }
  if (Capacitor.isNativePlatform()) {
    try {
      await Browser.open({
        url,
        presentationStyle: 'popover',
        windowName: '_self',
      });
    } catch (e) {
      console.error('[external] Browser.open failed:', e?.message || e);
      window.location.href = url;
    }
  } else {
    window.location.href = url;
  }
}
